import Splitting from 'splitting'
import 'splitting/dist/splitting.css'
import 'splitting/dist/splitting-cells.css'
import modular from 'modujs'
import * as modules from './modules'

Splitting()
const Modular = modular
const app = new Modular({
  modules
})
app.init(app)
